export default __webpack_public_path__ + "img/cadooz-logo.38c38ac8.svg";